import { useState } from "react";
import { Box } from "@mui/material";
import type { ChatRailTokens } from "../../tokens";

export function JsonResultRenderer({ payload, T }: { payload: unknown; T: ChatRailTokens }) {
  const [open, setOpen] = useState(false);
  const text = (() => {
    if (typeof payload === "string") return payload;
    try {
      return JSON.stringify(payload, null, 2);
    } catch {
      return String(payload);
    }
  })();
  const truncated = text.length > 240;
  const display = !open && truncated ? text.slice(0, 240) + "…" : text;
  return (
    <Box>
      <Box
        component="pre"
        sx={{
          fontFamily: T.mono,
          fontSize: T.fs_meta,
          color: T.text,
          bgcolor: T.panel2,
          border: `1px solid ${T.hair}`,
          borderRadius: `${T.r_xs}px`,
          p: 1,
          m: 0,
          maxHeight: open ? 400 : 160,
          overflow: "auto",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {display}
      </Box>
      {truncated && (
        <Box
          component="button"
          type="button"
          onClick={() => setOpen((v) => !v)}
          sx={{
            mt: 0.5,
            border: "none",
            bgcolor: "transparent",
            cursor: "pointer",
            color: T.accent,
            fontSize: T.fs_micro,
            p: 0,
            "&:hover": { textDecoration: "underline" },
          }}
        >
          {open ? "Collapse" : "Expand"}
        </Box>
      )}
    </Box>
  );
}
